import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import React, { forwardRef, useMemo } from "react";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import PageRecord from "models/view-models/page-record";

export interface EditPageMenuItemProps extends ButtonProps {
    page: PageRecord;
    onClick: () => void;
}
const CSS_CLASS_NAME = "c-page-context-menu";

const EditPageMenuItem = forwardRef<HTMLButtonElement, EditPageMenuItemProps>(
    (props, ref) => {
        const { page, onClick, children, ...rest } = props;
        const { t } = useLocalization();
        const { can } = usePageActionPermission(page);
        const canEdit = useMemo(() => can(PageAction.Edit), [can]);

        return (
            <>
                {canEdit && (
                    <Button
                        ref={ref}
                        accessibleText={t("editItem", {
                            item: t("page"),
                        })}
                        cssClassName={`${CSS_CLASS_NAME}__button`}
                        onClick={onClick}
                        {...rest}>
                        <Icon type={Icons.Pencil} />
                        {t("editItem", {
                            item: t("page"),
                        })}
                    </Button>
                )}
            </>
        );
    }
);

export default EditPageMenuItem;
